import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/rtu/@section1/page.tsx");
